import React from 'react';
import { Link } from 'react-router-dom';
import { UserShape } from '../shapes';

export default class AccountTacks extends React.Component {

  static propTypes = {
    user: UserShape
  }

  render() {
    if (this.props.user.get('tacksCount') > 0) {
      return this.renderTacksMeta();
    } else {
      return this.renderGettingStarted();
    }
  }

  renderTacksMeta() {
    return(
      <div className='sidebar'>
        <b>Tacks</b>
        <ul className='item-meta'>
          <li><Link to='/tack_board/active_tacks'>Active</Link>: { this.props.user.get('activeTacksCount') }</li>
          <li><Link to='/tack_board/queued_tacks'>Queued</Link>: { this.props.user.get('queuedTacksCount') }</li>
          <li><Link to='/tack_board/finished_tacks'>Finished</Link>: { this.props.user.get('finishedTacksCount') }</li>
        </ul>
      </div>
    );
  }

  renderGettingStarted() {
    return (
      <div className='sidebar'>
        <div>
          <b>Tacks</b>: 0
        </div>
        <div>
          <Link to='/tack_board/active_tacks'>Start tacking</Link>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/account_tacks.jsx